<!-- Customer Journey View Side Panel -->
<div class="customer-journey-side-panel">
    <div class="side-panel-overlay" (click)="closeQuestionModal()"></div>
    <div class="side-panel-container">
        <div class="side-panel-header">
            <div class="header-label">Customer Journey View</div>
            <div class="header-actions">
                <button class="close-button" (click)="closeQuestionModal()">
                    <img src="./assets/images/close.svg">
                </button>
            </div>
        </div>

        <div class="side-panel-content">

            <div class="customer-journey-view-container">
                <ul class="ltms-tabs">
                    <li class="ltms-tab" [ngClass]="{'ltms-active-tab': activeTab.key == tab.key}"
                        *ngFor="let tab of tabs" (click)="changeTab(tab)">{{tab.name}}</li>
                </ul>
                <div class="customer-journey-tab-content" id="overview_tab" *ngIf="activeTab.key == 'overview'">

                    <!-- Panel Description -->
                    <div class="panel-description">
                        Understand Individual Relationships! The Relationship View is your single source of truth for
                        each customer's unified view, tracing their lifetime journey from first contact to their latest
                        interaction. Track NPS, explore feedback history, and pinpoint pivotal moments to discover
                        crucial connections for personalized engagement. Understand how they evolve and build stronger,
                        lasting loyalty.
                    </div>

                    <!-- Panel Actions -->
                    <div class="panel-actions">
                        <button class="action-btn" aria-label="Profile" *ngIf="selectedProfileType == 'user_name'">
                            <svg class="profile-icon-img">
                                <use [attr.xlink:href]="'./assets/images/icons.svg#user-circle'"></use>
                            </svg>
                            <span class="profile-text">{{customerDetail.user_id}}</span>
                        </button>
                        <button class="action-btn" aria-label="Email" *ngIf="selectedProfileType == 'email_address'">
                            <svg class="profile-icon-img">
                                <use [attr.xlink:href]="'./assets/images/icons.svg#email'"></use>
                            </svg>
                            <span class="profile-text">{{customerDetail.user_id}}</span>
                        </button>
                        <button class="action-btn" aria-label="Phone" *ngIf="selectedProfileType == 'phone_number'">
                            <svg class="profile-icon-img">
                                <use [attr.xlink:href]="'./assets/images/icons.svg#phone-no'"></use>
                            </svg>
                            <span class="profile-text">{{customerDetail.user_id}}</span>
                        </button>
                        <button class="action-btn subscriber-id-btn" aria-label="Subscriber ID"
                            *ngIf="selectedProfileType == 'customer_id'">
                            <svg class="profile-icon-img">
                                <use [attr.xlink:href]="'./assets/images/icons.svg#tag'"></use>
                            </svg>
                            <span>{{customerDetail.user_id}}</span>
                        </button>
                    </div>

                    <div class="customer-journey-info-row">
                        <div class="customer-journey-info-card total-responses">
                            <div class="info-title">Total Responses</div>
                            <div class="info-value">{{customerDetail.total_responses|| '0'}}</div>
                            <div class="info-desc">Repeat customer responses across all journey stages.</div>
                        </div>
                        <div class="customer-journey-info-card customers-nps" [ngClass]="{
                            'unavailable-nps': npsType == 'unavailable',
                            'positive-nps': npsType == 'positive',
                            'nutral-nps': npsType == 'neutral',
                            'negative-nps': npsType == 'negative'
                           }">
                            <div class="info-title">Repeat Customers NPS®</div>
                            <div class="info-value">{{customerDetail.nps|| 'NA'}}</div>
                            <div class="info-desc">Tracks loyalty for returning customers and shows their impact on the
                                overall NPS</div>
                        </div>
                        <div class="customer-journey-info-card promoter">
                            <div class="info-title">Promoter ratings</div>
                            <div class="info-value">{{customerDetail.promoter|| '0'}}</div>
                            <div class="info-desc">Customers highly satisfied and eager to recommend your brand.</div>
                        </div>
                        <div class="customer-journey-info-card passive">
                            <div class="info-title">Passive ratings</div>
                            <div class="info-value">{{customerDetail.passive|| '0'}}</div>
                            <div class="info-desc">Customers who are satisfied but not fully enthusiastic.</div>
                        </div>
                        <div class="customer-journey-info-card detractor">
                            <div class="info-title">Detractors Ratings</div>
                            <div class="info-value">{{customerDetail.detractor|| '0'}}</div>
                            <div class="info-desc">Customers dissatisfied and unlikely to recommend.</div>
                        </div>
                    </div>
                    <div class="customer-journey-charts-row">
                        <div class="customer-journey-chart-card" style="height: 600px;">
                            <div class="chart-title">Repeat Customer NPS by Journey Stage</div>
                            <div class="chart-desc">Highlights how repeat customer NPS moves at every journey stage.
                            </div>
                            <div class="bar-chart-container"
                                *ngIf="!isChartDataLoading && barChartConfig?.data?.labels?.length > 0">
                                <app-litmus-chart-beta [chartConfigs]="barChartConfig"
                                    [chartData]="barChartConfig.data"></app-litmus-chart-beta>
                            </div>
                            <div class="loader-frame" *ngIf="isChartDataLoading">
                                <app-ltms-loader></app-ltms-loader>
                            </div>
                            <div class="loader-frame"
                                *ngIf="!isChartDataLoading && (barChartConfig?.data?.labels?.length == 0 || !barChartConfig?.data?.labels?.length)">
                                <div class="error-message">No Data available.</div>
                            </div>
                        </div>
                    </div>
                    <div class="customer-journey-charts-row">
                        <div class="customer-journey-chart-card" style="height: 620px;">
                            <div class="chart-title">Journey-wise Rating Trend</div>
                            <div class="chart-desc">Highlights how customer ratings change along the journey.</div>

                            <div class="chart-swithes" *ngIf="!isFeedsLoading && lifetimeResponses.length > 0">
                                <span class="view-by-text">View by</span>
                                <app-score-dropdown-menu [config]="viewTypeDropdown.config"
                                    [selectedOption]="viewTypeDropdown['selectedOption']"
                                    [options]="viewTypeDropdown.options"
                                    (selectedOptionChange)="changeJourney($event)"></app-score-dropdown-menu>
                            </div>
                            <div class="line-chart-container"
                                *ngIf="!isLineChartDataLoading && lineChartData?.labels?.length > 0">
                                <app-litmus-chart-beta [chartConfigs]="lineChartConfig"
                                    [chartData]="lineChartConfig.data"></app-litmus-chart-beta>
                            </div>
                            <div class="loader-frame" *ngIf="isLineChartDataLoading">
                                <app-ltms-loader></app-ltms-loader>
                            </div>
                            <div class="loader-frame"
                                *ngIf="!isLineChartDataLoading &&  (lifetimeResponses.length == 0 || !lineChartData?.labels || lineChartData?.labels?.length == 0)">
                                <div class="error-message">No Data available.</div>
                            </div>
                        </div>
                    </div>
                    <div class="customer-journey-tables-row">
                        <div class="customer-journey-table-card">
                            <div class="table-card-header">
                                <div class="table-card-header-left">
                                    <div class="table-title">Lifetime Response Details</div>
                                    <div class="table-desc">Access detailed feedback! See ratings, comments, interaction
                                        dates, and response times all in one place.</div>

                                </div>
                                <div class="table-card-header-right">
                                    <div class="table-card-filter-buttons">
                                        <button class="filter-button promoter" [ngClass]="{'active': activeTableFilter == 'promoter'}" (click)="changeTableFilter('promoter')">Promoter</button>
                                        <button class="filter-button passive" [ngClass]="{'active': activeTableFilter == 'passive'}" (click)="changeTableFilter('passive')">Passive</button>
                                        <button class="filter-button detractor" [ngClass]="{'active': activeTableFilter == 'detractor'}" (click)="changeTableFilter('detractor')">Detractor</button>
                                    </div>
                                </div>
                            </div>
                            <div class="table-responsive" *ngIf="!isFeedsLoading && lifetimeResponses.length > 0">
                                <table>
                                    <thead>
                                        <tr>
                                            <th (click)="sortTable('formated_feedback_request_date')"
                                                [ngClass]="{'sorted-column': isColumnSorted('formated_feedback_request_date')}"
                                                class="sortable-header">
                                                Req. Date
                                                <span
                                                    class="sort-icon">{{getSortIcon('formated_feedback_request_date')}}</span>
                                            </th>
                                            <th (click)="sortTable('formated_created_date')"
                                                [ngClass]="{'sorted-column': isColumnSorted('formated_created_date')}"
                                                class="sortable-header">
                                                Res. Date
                                                <span class="sort-icon">{{getSortIcon('formated_created_date')}}</span>
                                            </th>
                                            <th (click)="sortTable('primary_rating')"
                                                [ngClass]="{'sorted-column': isColumnSorted('primary_rating')}"
                                                class="sortable-header">
                                                Rating
                                                <span class="sort-icon">{{getSortIcon('primary_rating')}}</span>
                                            </th>
                                            <th (click)="sortTable('comments')"
                                                [ngClass]="{'sorted-column': isColumnSorted('comments')}"
                                                class="sortable-header" style="max-width: 489px;">
                                                Primary Comment
                                                <span class="sort-icon">{{getSortIcon('comments')}}</span>
                                            </th>
                                            <th (click)="sortTable('project_name')"
                                                [ngClass]="{'sorted-column': isColumnSorted('project_name')}"
                                                class="sortable-header">
                                                Project
                                                <span class="sort-icon">{{getSortIcon('project_name')}}</span>
                                            </th>
                                            <th (click)="sortTable('journey_name')"
                                                [ngClass]="{'sorted-column': isColumnSorted('journey_name')}"
                                                style="max-width: 165px;" class="sortable-header">
                                                Journey
                                                <span class="sort-icon">{{getSortIcon('journey_name')}}</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let feed of sortedLifetimeResponses" class="feedback-row"
                                            (click)="openFeedDetails(feed)">
                                            <td
                                                [ngClass]="{'sorted-data-column': isColumnSorted('formated_feedback_request_date')}" class="table-date-column">
                                                {{feed.formated_feedback_request_date}}</td>
                                            <td
                                                [ngClass]="{'sorted-data-column': isColumnSorted('formated_created_date')}" class="table-date-column">
                                                {{feed.formated_created_date}}</td>
                                            <td [ngClass]="{'sorted-data-column': isColumnSorted('primary_rating')}">
                                                {{feed.primary_rating}}</td>
                                            <td [ngClass]="{'sorted-data-column': isColumnSorted('comments'),'no-comment-provided': feed.no_comment_provided}"
                                                class="comment-column" [innerHTML]="feed.comments"></td>
                                            <td [ngClass]="{'sorted-data-column': isColumnSorted('project_name')}">
                                                {{feed.project_name}}</td>
                                            <td [ngClass]="{'sorted-data-column': isColumnSorted('journey_name')}"
                                                style="max-width: 165px;">{{feed.journey_name}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="loader-frame" *ngIf="isFeedsLoading">
                                <app-ltms-loader></app-ltms-loader>
                            </div>
                            <div class="loader-frame" *ngIf="!isFeedsLoading && (lifetimeResponses.length == 0)">
                                <div class="error-message">No Data available.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="customer-journey-tab-content" id="timeline_tab" *ngIf="activeTab.key == 'timeline'">
                    <p class="panel-description">Trace a customer’s history! View engagements, feedback, and
                        satisfaction
                        changes over time.</p>

                    <div class="main-timeline" *ngIf="!isFeedsLoading && lifetimeResponses.length > 0">
                        <!-- Timeline vertical line -->
                        <!-- <div class="timeline-line">
                        </div> -->
                        <!-- Recent Label -->
                        <div class="timeline-label-container">
                            <div class="timeline-label">
                                Recent
                            </div>
                        </div>

                        <ng-container *ngFor="let item of lifetimeResponses; let i = index">
                            <!-- Loop through timeline items -->
                            <div class="timeline-row odd-timeline-row" *ngIf="i % 2 === 0">
                                <!-- Timeline dot -->
                                <!-- <div class="timeline-dot"></div> -->


                                <div class="timeline-column">
                                    <!-- Message Container -->
                                    <div class="rating-card" [ngClass]="{
                            'light-red-rating': item?.feed_params?.primary_rating <= 6,
                            'light-yellow-rating': item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8,
                            'light-green-rating': item?.feed_params?.primary_rating >= 9
                            }" [ngStyle]="{
                            'background-color': (item?.feed_params?.primary_rating === 'NA' || item?.feed_params?.primary_rating == null || item?.feed_params?.primary_rating == undefined) ? '#F2F3F7' : 
                            (item?.feed_params?.primary_rating >= 0 && item?.feed_params?.primary_rating <= 6 ? detractorBackgroundColor :
                            (item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8 ? passiveBackgroundColor :
                            promoterBackgroundColor)),
                            'background-image': (item?.feed_params?.primary_rating === 'NA' || item?.feed_params?.primary_rating == null || item?.feed_params?.primary_rating == undefined) ? 'none' :
                                                (item?.feed_params?.primary_rating <= 6 ? 'url(assets/images/verbatim/emoticon_2.svg)' :
                                                (item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8 ? 'url(assets/images/verbatim/emoticon_8.svg)' :
                                                (item?.feed_params?.primary_rating == 9 ? 'url(assets/images/verbatim/emoticon_9.svg)' : 
                                                'url(assets/images/verbatim/emoticon_10.svg)'))),
                            'background-position': 'right 15px bottom 15px',
                            'background-size': '50px auto',
                            'background-repeat': 'no-repeat',
                            'padding-bottom': '12px'
                            }">
                                        <!-- Rating Badge -->
                                        <div class="rating-badge" [ngClass]="{
                                'badge-light-red': item?.feed_params?.primary_rating !== 'NA' && item?.feed_params?.primary_rating <= 6,
                                'badge-light-yellow': item?.feed_params?.primary_rating !== 'NA' && item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8,
                                'badge-light-green': item?.feed_params?.primary_rating !== 'NA' && item?.feed_params?.primary_rating >= 10,
                                'badge-light-purple': item?.feed_params?.primary_rating === 9,
                                'badge-light-grey': (item?.feed_params?.primary_rating === 'NA' || item?.feed_params?.primary_rating == null || item?.feed_params?.primary_rating == undefined)
    
                            }" [ngStyle]="{ left: i % 2 !== 0 ? '13px' : '13px' }">
                                            {{ (item?.feed_params?.primary_rating === 'NA' ||
                                            item?.feed_params?.primary_rating == null ||
                                            item?.feed_params?.primary_rating ==
                                            undefined)?'NA':item?.feed_params?.primary_rating }}
                                        </div>
                                        <!-- <p class="rating-comment">
                                {{ item["Comments"] === 'NA' ? 'No comment provided' : item["Comments"] }}
                            </p> -->
                                        <!-- Message Content -->
                                        <p class="rating-comment"
                                            [ngClass]="{'no-comment-provided': item?.no_comment_provided}"
                                            [innerHTML]="item?.comments">
                                        </p>
                                        <div class="journey-info-container">
                                            <div class="journey-info-item">
                                                <div class="journey-info-label">Project :</div>
                                                <div class="journey-info-value">{{item?.project_name}}</div>
                                            </div>
                                            <div class="journey-info-item">
                                                <div class="journey-info-label">Journey :</div>
                                                <div class="journey-info-value">{{item?.journey_name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="timeline-column ">
                                    <!-- Date Container -->
                                    <div class="responded-date"
                                        [ngClass]="{ 'left-align': i % 2 === 0, 'right-align': i % 2 !== 0 }">
                                        {{ item.formated_created_date.split(':')[0] }}
                                    </div>
                                </div>
                            </div>
                            <div class="timeline-row even-timeline-row" *ngIf="i % 2 !== 0">
                                <!-- Timeline dot -->
                                <!-- <div class="timeline-dot"></div> -->

                                <div class="timeline-column ">
                                    <!-- Date Container -->
                                    <div class="responded-date"
                                        [ngClass]="{ 'left-align': i % 2 === 0, 'right-align': i % 2 !== 0 }">
                                        {{ item.formated_created_date.split(':')[0] }}
                                    </div>
                                </div>
                                <div class="timeline-column">
                                    <!-- Message Container -->
                                    <div class="rating-card" [ngClass]="{
                            'light-red-rating': item?.feed_params?.primary_rating <= 6,
                            'light-yellow-rating': item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8,
                            'light-green-rating': item?.feed_params?.primary_rating >= 9
                            }" [ngStyle]="{
                            'background-color': (item?.feed_params?.primary_rating === 'NA' || item?.feed_params?.primary_rating == null || item?.feed_params?.primary_rating == undefined) ? '#F2F3F7' : 
                            (item?.feed_params?.primary_rating >= 0 && item?.feed_params?.primary_rating <= 6 ? detractorBackgroundColor :
                            (item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8 ? passiveBackgroundColor :
                            promoterBackgroundColor)),
                            'background-image':(item?.feed_params?.primary_rating === 'NA' || item?.feed_params?.primary_rating == null || item?.feed_params?.primary_rating == undefined) ? 'none' :
                                                (item?.feed_params?.primary_rating <= 6 ? 'url(assets/images/verbatim/emoticon_2.svg)' :
                                                (item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8 ? 'url(assets/images/verbatim/emoticon_8.svg)' :
                                                (item?.feed_params?.primary_rating == 9 ? 'url(assets/images/verbatim/emoticon_9.svg)' : 
                                                'url(assets/images/verbatim/emoticon_10.svg)'))),
                            'background-position': 'right 15px bottom 15px',
                            'background-size': '50px auto',
                            'background-repeat': 'no-repeat',
                            'padding-bottom': '12px'
                            }">
                                        <!-- Rating Badge -->
                                        <div class="rating-badge" [ngClass]="{
                                'badge-light-red': item?.feed_params?.primary_rating !== 'NA' && item?.feed_params?.primary_rating <= 6,
                                'badge-light-yellow': item?.feed_params?.primary_rating !== 'NA' && item?.feed_params?.primary_rating >= 7 && item?.feed_params?.primary_rating <= 8,
                                'badge-light-green': item?.feed_params?.primary_rating !== 'NA' && item?.feed_params?.primary_rating >= 10,
                                'badge-light-purple': item?.feed_params?.primary_rating === 9,
                                'badge-light-grey': (item?.feed_params?.primary_rating === 'NA' || item?.feed_params?.primary_rating == null || item?.feed_params?.primary_rating == undefined)
    
                            }" [ngStyle]="{ left: i % 2 !== 0 ? '13px' : '13px' }">
                                            {{ (item?.feed_params?.primary_rating === 'NA' ||
                                            item?.feed_params?.primary_rating == null ||
                                            item?.feed_params?.primary_rating ==
                                            undefined)?'NA':item?.feed_params?.primary_rating }}
                                        </div>
                                        <!-- <p class="rating-comment">
                                {{ item["Comments"] === 'NA' ? 'No comment provided' : item["Comments"] }}
                            </p> -->
                                        <!-- Message Content -->
                                        <p class="rating-comment"
                                            [ngClass]="{'no-comment-provided': item?.no_comment_provided}"
                                            [innerHTML]="item?.comments">
                                        </p>
                                        <div class="journey-info-container">
                                            <div class="journey-info-item">
                                                <div class="journey-info-label">Project :</div>
                                                <div class="journey-info-value">{{item?.project_name}}</div>
                                            </div>
                                            <div class="journey-info-item">
                                                <div class="journey-info-label">Journey :</div>
                                                <div class="journey-info-value">{{item?.journey_name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </ng-container>


                        <!-- Oldest Label -->
                        <div class="timeline-label-container">
                            <div class="timeline-label">
                                Oldest
                            </div>
                        </div>
                    </div>
                    <div class="loader-frame" *ngIf="isFeedsLoading">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="loader-frame" *ngIf="!isFeedsLoading && (lifetimeResponses.length == 0)">
                        <div class="error-message">No Data available.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-feed-detail-panel (onPageChange)="onPageChange($event)"></app-feed-detail-panel>